import { useContext, useState } from "react";
import { OrgIdContext } from "../../store/orgId_context";
import classes from "./addCustomerElements.module.scss";

const OrganizationId = (props) => {
    const [copied,setCopied] =  useState();

    const { mainOrgId } =useContext(OrgIdContext);
    const onIdClick = () =>{
        navigator.clipboard.writeText(mainOrgId);

        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    return(
        <div className={classes["orgIdText"]} {...props}>
            Your organization Id is: 
            <span className={classes["orgId"]} onClick={onIdClick}>{mainOrgId}</span>
            {copied && <span style={{paddingLeft:"1rem"}}>Copied!</span>}
        </div>
    )
}

export default OrganizationId;